import React from 'react';
import CommonInvoiceAdd from '../../../components/Invoice/CommonInvoiceAdd';

const SaleInvoiceAdd = () => {
    return (
        <CommonInvoiceAdd
            isSale={true}
            isPurchase={false}
            isRefund={false}
            pageName="Ön Muhasebe > Fiş / Faturalar > Satış Faturaları"
        />
    )
}

export default SaleInvoiceAdd;